'use client';

import { ReactNode, useEffect } from 'react';
import useSmartEdit from '@smartedit/hooks/useSmartEdit';
import useCmsTicketId from '@hooks/useCmsTicketId';
import { PageWithSlots } from '@api/interfaces/pageApi';
import CmsTemplate from '@organisms/CmsTemplate/CmsTemplate';

export interface Props {
  children?: ReactNode;
  cmsPage?: PageWithSlots;
}

const Page = ({ children, cmsPage }: Props) => {
  const { isSmartEditEnabled, toggleBodyClasses } = useSmartEdit(useCmsTicketId());

  useEffect(() => {
    if (cmsPage && isSmartEditEnabled) {
      toggleBodyClasses(true, cmsPage?.uid, cmsPage?.uuid, cmsPage?.catalogVersionUuid);
    }

    return () => {
      toggleBodyClasses(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSmartEditEnabled, cmsPage]);

  return <>{cmsPage && <CmsTemplate cmsPage={cmsPage}>{children}</CmsTemplate>}</>;
};

export default Page;
